import './index.css';
import {  useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import icon from "assets/logoshutter.png";
import { blurOnMouseUp } from 'utils/focus';
import { navLinks, socialLinks  } from "components/Navbar/navData";
import { NavLink } from 'react-router-dom';
import { useAppContext } from 'hooks';
const Footer = () => {
  const { menuOpen, dispatch } = useAppContext();

  const [hashKey, setHashKey] = useState();

  const handleNavClick = () => {
    setHashKey(Math.random().toString(32).substr(2, 8));
  };

  const handleMobileNavClick = () => {
    handleNavClick();
    if (menuOpen) dispatch({ type: 'toggleMenu' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footerCta">
          <div className="row">
            <div className="threeitem">
              <div className="singleCta">
                <i className="fas fa-phone"></i>
                <div className="ctaText">
                  <h4>Call us</h4>
                  <span>+20 121 086 4493</span>
                  <span>+20 120 878 2123</span>
                </div>
              </div>
            </div>
            <div className="threeitem">
              <div className="singleCta">
                <i className="far fa-envelope-open"></i>
                <div className="ctaText">
                  <h4>Mail us</h4>
                  <span>Info@shutterfly-eg.com</span>
                </div>
              </div>
            </div>
            <div className="threeitem">
              <div className="singleCta">
                <i className="fas fa-map-marker-alt"></i>
                <div className="ctaText">
                  <h4>Find us</h4>
                  <span>V2 Makani Compound, Katameya, Cairo, Egypt</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footerContent pt5 pb5">
          <div className="row">
            <div className="threeitem">
              <div className="footerWidget">
                <div className="footerLogo">
                  <a href="/#intro">
                    <img
                      src={icon}
                      className="img-fluid"
                      alt="logo"
                    />
                  </a>
                </div>
              </div>
              </div>
              <div className="threeitem">
              <div className="footerWidget">
              <div className="footerText">
                  <p>
                  Shutterfly is a premier media production company specializing in photography and videography for corporate events. With a rich history in freelance services, we bring extensive expertise to the corporate sector.
                  </p>
                </div>

              </div>
              </div>
              <div className="threeitem">
              <div className="footerWidget">
                <div className="footerWidgetHeading">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                {navLinks.map(({ label, pathname, hash }) => (
                    <li key={label}>
                      <NavLink
                        to={{ pathname, hash, state: hashKey  }}
                        key={label}
                        onClick={handleMobileNavClick}
                        onMouseUp={blurOnMouseUp}
                      >
                        {label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>


          </div>
        </div>
        <div className="footerSocialIcon">
                  <span>Follow us</span>
                  <div className="icons">
            <a href={socialLinks[3].url} target="_blank" rel="noopener noreferrer" data-aos="zoom-in">
                <div className="layer">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span className=" fa fas fa-envelope"></span>
                </div>
                <div className="text">
                    Gmail
                </div>
            </a>
            <a href={socialLinks[1].url} target="_blank" rel="noopener noreferrer" data-aos="zoom-in">
                <div className="layer">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span className="fab fa-whatsapp"></span>
                </div>
                <div className="text">
                    Whatsapp
                </div>
            </a>
            <a href={socialLinks[0].url} target="_blank" rel="noopener noreferrer" data-aos="zoom-in">
                <div className="layer">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span className="fab fa-instagram"></span>
                </div>
                <div className="text">
                    Instagram
                </div>
            </a>
            <a href={socialLinks[2].url} target="_blank" rel="noopener noreferrer" data-aos="zoom-in">
                <div className="layer">
                   <span></span>
                   <span></span>
                   <span></span>
                   <span></span>
                   <span className="fab fa-facebook"></span>
                </div>
                <div className="text">
                    Facebook
                </div>
            </a>
            <a href={socialLinks[3].url} target="_blank" rel="noopener noreferrer" data-aos="zoom-in">
                <div className="layer">
                   <span></span>
                   <span></span>
                   <span></span>
                   <span></span><span className="fab fa-linkedin"></span>
                </div>
                <div className="text">
                   LinkedIn
                </div>
             </a>
             <a href={socialLinks[4].url} target="_blank" rel="noopener noreferrer" data-aos="zoom-in">
                <div className="layer">
                   <span></span>
                   <span></span>
                   <span></span>
                   <span></span>
                   <span className="fab fa-behance"></span>
                </div>
                <div className="text">
                   Behance
                </div>
             </a>                 
          </div>
       </div>
      </div>

      <div className="copyrightArea">
        <div className="copyrightText">
          <p>&copy; 2024, All creative rights belong to <strong>Shutter Fly</strong>.</p>
          <p>Proudly designed and developed by <a href="https://www.amara-tech.shop/">AmaraTech</a>.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
